var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 15.1668C4.04732 15.1668 0.833984 11.9535 0.833984 8.00016C0.833984 4.04683 4.04732 0.833496 8.00065 0.833496C11.954 0.833496 15.1673 4.04683 15.1673 8.00016C15.1673 11.9535 11.954 15.1668 8.00065 15.1668ZM8.00065 1.8335C4.60065 1.8335 1.83398 4.60016 1.83398 8.00016C1.83398 11.4002 4.60065 14.1668 8.00065 14.1668C11.4007 14.1668 14.1673 11.4002 14.1673 8.00016C14.1673 4.60016 11.4007 1.8335 8.00065 1.8335Z",
    fill: "#020202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05102 10.3867C6.91768 10.3867 6.79102 10.3334 6.69768 10.2401L4.81102 8.3534C4.61768 8.16006 4.61768 7.84007 4.81102 7.64673C5.00435 7.4534 5.32435 7.4534 5.51768 7.64673L7.05102 9.18007L10.4777 5.7534C10.671 5.56007 10.991 5.56007 11.1844 5.7534C11.3777 5.94673 11.3777 6.26673 11.1844 6.46006L7.40435 10.2401C7.31102 10.3334 7.18435 10.3867 7.05102 10.3867Z",
    fill: "#020202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.cce865e8cb684ffe7147838dff3169bf.svg";
export { ForwardRef as ReactComponent };